"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const PricingTableCell_1 = require("./PricingTableCell");
class PricingTable {
    constructor({ creativeTypeId, cells }) {
        this.toJSON = () => ({
            creativeTypeId: this.creativeTypeId,
            cells: this.cells,
        });
        // creative formatを元にpointを返す
        this.getPoint = (creativeFormat, itemType) => {
            const supportingAspectRatioKey = creativeFormat.attribute.aspectRatio.size.key;
            const supportingPlaybackTimeLength = creativeFormat.attribute.playbackTime
                ? creativeFormat.attribute.playbackTime.seconds.toString()
                : null;
            let cells, cell;
            cells = this.cells.filter(_cell => {
                return _cell.supportingAspectRatioKey == supportingAspectRatioKey;
            });
            if (cells.length == 0) {
                cells = this.cells.filter(_cell => {
                    return _cell.supportingAspectRatioKey == 'all';
                });
            }
            if (creativeFormat.creativeType.key === 'static_image') {
                cell = cells[0];
            }
            else {
                cell = cells.find(_cell => {
                    return _cell.supportingPlaybackTimeLength == supportingPlaybackTimeLength;
                });
            }
            if (!cell) {
                throw new Error('this format`s point not found');
            }
            return cell.getPoint(creativeFormat, itemType);
        };
        this.creativeTypeId = creativeTypeId;
        this.cells = cells;
    }
}
PricingTable.fromJSON = (json) => {
    const { creativeTypeId, cells } = Object.assign({}, json);
    if (typeof creativeTypeId !== 'string')
        throw new Error('.creativeTypeId must be an string');
    if (!Array.isArray(cells))
        throw new Error('.cells must be a Array');
    return new PricingTable({
        creativeTypeId,
        cells: cells ? cells.map((_cell) => PricingTableCell_1.default.fromJSON(_cell)) : [],
    });
};
exports.default = PricingTable;
